import FormDisableableMixin from 'mixins/FormDisableableMixin'

export default {
    mixins: [FormDisableableMixin],

    props: {
        isInvalid: { type: Boolean, default: false },
        hasAutofocus: { type: Boolean, default: false },
        isRequired: { type: Boolean, default: false },
        attrs: { type: Object, default: null },
    },

    methods: {
        change(value) {
            this.emitEvent({
                name: 'change',
                payload: value instanceof Event ? value.target.value : value,
            })
        },
    },
}
